import { render, staticRenderFns } from "./moreOXTHDPOUOE.vue?vue&type=template&id=d5dedf4e&lang=pug&"
import script from "./moreOXTHDPOUOE.vue?vue&type=script&lang=js&"
export * from "./moreOXTHDPOUOE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports